import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { HudNav } from "@/components/HudNav";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Workshop from "@/pages/Workshop";
import Partnership from "@/pages/Partnership";
import Races from "@/pages/Races";
import Media from "@/pages/Media";
import Shop from "@/pages/Shop";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

// Every public route exists twice: "/x" (CZ) and "/en/x" (EN)
const ROUTES = [
  { path: "", element: <Home /> },
  { path: "o-mne", element: <About /> },
  { path: "dilna", element: <Workshop /> },
  { path: "spoluprace", element: <Partnership /> },
  { path: "zavody", element: <Races /> },
  { path: "media", element: <Media /> },
  { path: "shop", element: <Shop /> },
  { path: "kontakt", element: <Contact /> },
  { path: "admin", element: <Admin /> },
];

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {ROUTES.map((r) => (
          <Route key={`cz-${r.path}`} path={`/${r.path}`} element={r.element} />
        ))}
        {ROUTES.map((r) => (
          <Route key={`en-${r.path}`} path={`/en/${r.path}`} element={r.element} />
        ))}
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <CartProvider>
          <div className="relative min-h-screen bg-[#07080A] text-foreground">
            <div className="grain-overlay" aria-hidden="true" />
            <ScrollToTop />
            <HudNav />
            <AnimatedRoutes />
            <Footer />
            <CartDrawer />
            <Toaster position="bottom-right" theme="dark" richColors />
          </div>
        </CartProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
